import React, { useEffect } from 'react';
import Select from '../../common/Form/Select';
import { useFormContext } from 'react-hook-form';

export const poAssetCategories = [
    {
        "key": 1,
        "label": "Hardware",
        "value": 'hardware'
    },
    {
        "key": 2,
        "label": "Software",
        "value": "software"
    },
    {
        "key": 3,
        "label": "Service",
        "value": "service"
    },
    {
        "key": 4,
        "label": "Subscription",
        "value": 'subscription'
    },
    {
        "key": 5,
        "label": "Others",
        "value": 'others'
    }
]

export default function Categories({ name, label, onChange = () => { }, required = false, prefill = [] }) {
    const methods = useFormContext();

    useEffect(() => {
        if (prefill && prefill.length > 0) {
            const find = poAssetCategories.find((elem) => prefill.includes(elem.value));
            if (find) {
                methods.setValue(name, find);
            }
        }
    }, [prefill]);

    return (
        <>
            <Select
                className='w-full'
                label={label}
                name={name}
                options={poAssetCategories}
                isLoading={false}
                onChange={(event) => {
                    const value = event?.value;
                    onChange(value)
                }}
                required={required}
            />
        </>
    )
}